<template>
    <b-modal v-model="display" title="Clonar menú" size="xl" @ok="handleOk" :ok-title="(isProcessing) ? 'Procesando...' : 'Clonar'" cancel-title="Cancelar" :ok-disabled="isProcessing">
        <menus-main-card v-model="planIdPk" page-size=5 seleccionable  @titleChange="titleChange" hide-new :args="{origen: 'soloSupereasy'}"/>
        <hr>
        <b-form-group label="Nombre del plan">
            <b-form-input v-model="form.nombre" :readonly="isProcessing" label="Nombre del plan" />
        </b-form-group>
    </b-modal>
</template>

<script>
    import Axios from 'axios';
    import MenusMainCard from './MenusMainCard.vue';

    export default {

        name: 'MenuClonadoParaUsuario',

        components: { MenusMainCard },

        data: () => {
            return {
                display: false,
                isProcessing: false,
                usuarioIdPk: false,
                planIdPk: null,
                form: {
                    nombre: null
                }
            }
        },

        methods: {
            async handleOk($event){
                $event.preventDefault();
                this.isProcessing = true;
                try {
                    const response = await Axios.post('recetas/menusclone/' + this.usuarioIdPk + '/' + this.planIdPk + '/', this.form);
                    if(response.status){
                        this.$emit('refresh')
                        this.display = false;
                    }
                } catch(e){
                    console.error(e)
                }
                this.isProcessing = false;
            },
            titleChange(nombrePlan){
                this.form.nombre = nombrePlan;
            },
            clonarMenu(usuarioIdPk){
                this.usuarioIdPk = usuarioIdPk;
                this.display = true;
            }
        }
    }
</script>